import moment from 'moment';

export const mockPosts = [
  {
    id: 1,
    title: '大二碎记：在校园的烟火里，捡拾成长的星光',
    content: '这里是大二碎记的完整内容...大学二年级的生活充满了挑战和机遇，在校园的每一个角落，都能发现成长的痕迹。从图书馆的埋头苦读到操场上的挥洒汗水，从课堂上的激烈讨论到宿舍里的深夜畅谈，每一刻都值得珍藏。',
    summary: '大二校园生活的随笔，记录成长的点滴',
    date: '2025-12-22',
    tags: ['大二', '校园', '随笔'],
    author: 'zhou'
  },
  {
    id: 2,
    title: '武汉美食打卡全攻略：在烟火气里吃透江湖味',
    content: '武汉，一座充满江湖气息的城市，这里的美食同样充满了江湖味。从早餐的热干面、豆皮，到午餐的武昌鱼、莲藕排骨汤，再到晚餐的小龙虾、烧烤，每一道美食都承载着武汉人的热情与豪爽。本文将带你走遍武汉的大街小巷，品尝最地道的武汉美食。',
    summary: '武汉美食全攻略，带你吃遍武汉',
    date: '2025-12-22',
    tags: ['美食', '武汉', '攻略', '旅行'],
    author: 'zhou'
  },
  {
    id: 3,
    title: 'React Hooks 使用心得',
    content: 'React Hooks 是 React 16.8 引入的新特性，它让我们在函数组件中也能使用状态和其他 React 特性...',
    summary: '分享使用React Hooks的经验和技巧',
    date: '2025-12-20',
    tags: ['技术', 'React', '前端'],
    author: 'zhou'
  },
  {
    id: 4,
    title: '阅读《活着》有感',
    content: '余华的《活着》讲述了一个普通人在中国历史变迁中的沉浮人生...',
    summary: '对《活着》这本书的读后感和思考',
    date: '2025-12-18',
    tags: ['阅读', '文学', '思考'],
    author: 'zhou'
  }
];

// 模拟API调用
export const blogAPI = {
  // 获取文章列表
  getPosts: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mockPosts);
      }, 500);
    });
  },

  // 创建文章
  createPost: (post) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newPost = {
          ...post,
          id: Date.now(),
          date: moment().format('YYYY-MM-DD')
        };
        mockPosts.unshift(newPost);
        resolve(newPost);
      }, 500);
    });
  },

  // 更新文章
  updatePost: (id, updates) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const index = mockPosts.findIndex(post => post.id === id);
        if (index !== -1) {
          mockPosts[index] = { ...mockPosts[index], ...updates };
          resolve(mockPosts[index]);
        } else {
          reject(new Error('文章不存在'));
        }
      }, 500);
    });
  },

  // 删除文章
  deletePost: (id) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const index = mockPosts.findIndex(post => post.id === id);
        if (index !== -1) {
          mockPosts.splice(index, 1);
          resolve(true);
        } else {
          reject(new Error('文章不存在'));
        }
      }, 500);
    });
  }
};